module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAADJJREFUGBlj3PXU/j8DEYCJCDVgJSwwhW7SBxlhbGQaZiPRJg4FhYwwXyH7FBubaM8AADf8Cc9wVjeoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/new Patch.png
// module id = 113
// module chunks = 7